import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CreateExtensionOfferFlow } from './create-extension-offer-flow';
import { Drawer } from '@common/components';

// @TODO: Remove prop drilling of "assignment" and register
// this drawer as global in the Dialog Map. [WORK-215]
export function ExtendOfferDrawer({ assignment, trigger }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState(
    `Extend ${assignment.worksProfile.fullName}`
  );
  const [footer, setFooter] = useState(null);

  const onClose = () => setOpen(false);

  const onOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <a onClick={onOpen}>{trigger}</a>
      <Drawer
        open={open}
        onClose={onClose}
        className="ExtendOfferDrawer"
        title={title}
        footer={footer}
      >
        <CreateExtensionOfferFlow
          assignment={assignment}
          setTitle={setTitle}
          setDrawerFooter={setFooter}
          onDrawerClose={onClose}
        />
      </Drawer>
    </>
  );
}

ExtendOfferDrawer.propTypes = {
  assignment: PropTypes.object,
  trigger: PropTypes.any.isRequired,
};
